import { useMemo } from 'react';
import { IPromoModalProps } from '@cian/frontend-newbuilding-promo-modal-widget';
import { getCianMortgagePromoUrl, getPromoModalConfig } from '../../../utils/config';
import { useApplicationContext } from '../../../utils/withApplicationContext';

export const usePromoDetailsConfig = (): IPromoModalProps['config'] => {
  const { config } = useApplicationContext();
  const mortgagePartnerLink = getCianMortgagePromoUrl(config);
  const promoModalConfigRs = getPromoModalConfig(config);

  return useMemo(() => {
    return {
      listingBaseUrlDesktop: promoModalConfigRs?.listingBaseUrlDesktop,
      listingBaseUrlMobile: promoModalConfigRs?.listingBaseUrlMobile,
      fullCreditPriceModalText: promoModalConfigRs?.fullCreditPriceModalText,
      mortgagePartnerLink,
    };
  }, [promoModalConfigRs, mortgagePartnerLink]);
};
